<template lang="pug">
  aside.aside
    div.drag
    //Info
    p.name-simulation(v-if="check()") {{ this.$store.state.simulationInfo.name }}
    div.tit(v-if="view === 1")
      | パーツから選択
      select#select(@change="selCategory")
        option(value="all") すべて
        option(v-for="n in category",:value="n.cat") {{ n.name }}
    div.items(v-if="view === 1", :class="{top:check()}")
      Item(v-for="(n, i) in partsitems",v-if="n.display ===true",:dat="n",:key="i")
</template>

<script>
import store from '../../stores/index';
import Item from './Item';
import Info from './Info';
export default {
  name: 'SideMenu',
  data () {
    return {
      items: [],
      parts: [],
      parts2: [],
      // category: [],
      $tar: {},
      $drag: {},
      $info: {}
    };
  },
  components: {
    Item,
    Info
  },
  watch: {
  },
  methods: {
    selCategory (e) {
      this.parts2 = [];
      for (let prop in this.partsitems) {
        let val = Number(e.target.value);
        let cat = Number(this.partsitems[prop].cat);
        let itm = this.acopy(this.partsitems[prop]);
        if (val === cat || isNaN(val)) {
          itm.display = true;
        } else {
          itm.display = false;
        }
        this.parts2.push(itm);
      }
      store.commit('setPartsitems', this.parts2);
    },
    check () {
      if (this.$store.state.simulationInfo.id) {
        if (this.$store.state.simulationInfo.simulation_detail.length < this.$store.state.idx + 1) {
          return false;
        } else {
          return true;
        }
      }
    }
  },
  created () {
  },
  mounted () {
  }
};
</script>

<style lang="stylus" scoped>
  .aside
    position absolute
    z-index 2
    left 0
    top 51px
    bottom 0
    width 160px
    background-color #ffffff
    border-right 1px solid #dddddd
  .name-simulation
    margin 0
    padding 5px 10px 0
  .tit
    padding 5px 10px 5px
    font-size 12px
    font-weight bold
    color #2E7C80
    border-bottom 1px solid #dddddd
    user-select: none
    select
      width 100%
  .items
    position absolute
    left 0
    right 0
    top 62px
    bottom 0
    overflow-y auto
    padding 15px
  .top
    top 100px;
</style>



// WEBPACK FOOTER //
// src/components/sidemenu/SideMenu.vue